import api from '@pray/shared/utils/api';

export type ScheduleMultiPrayRadioDailySlot = {
  scheduledAt: string;
};

export type ScheduleMultiPrayRadioDailyResult = {
  scheduled: Array<{
    scheduled_at: string;
    daily_item_id: string;
    created_duplicate: boolean;
  }>;
  failed: Array<{
    scheduled_at: string;
    reason: string;
  }>;
};

/**
 * Schedules one Pray Radio daily item into multiple calendar slots (PB-37969).
 * An episode on the podcast host has a single pubdate, so the backend creates a
 * full duplicate item (its own episode) for every slot beyond the first.
 * Partial failures return 200 with the failed slots listed in `failed`.
 */
export async function scheduleMultiPrayRadioDaily({
  artistId,
  dailySeriesId,
  dailyItemId,
  slots,
}: {
  artistId: string;
  dailySeriesId: string;
  dailyItemId: string;
  slots: ScheduleMultiPrayRadioDailySlot[];
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailySeriesId) throw Error('Daily Series ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');
  if (!slots?.length) throw Error('At least one slot is required');

  const url = `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}/pray-radio-schedule-multi`;
  const response = await api.executePostRequest(url, {
    slots: slots.map((slot) => ({ scheduled_at: slot.scheduledAt })),
  });

  return response.data;
}
